// extracted by mini-css-extract-plugin
export default {"component":"OfficeTreeView_component__wBCQz","removeIcon":"OfficeTreeView_removeIcon__nhUYh"};